import React from 'react'

import './styles.scss'

import { IntroProps } from '../types'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

import backgroundImg from './img/background.jpg'

import heartImg from './img/heart.png'

const Intro = ({
  coupleData: { coupleSimplifiedName },
  buttonMessage,
  warningMessage,
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro357">
      <div className="animated-intro-small-all-breakpoints screen">
        <img
          className="background-kaVUlA"
          src={background || backgroundImg}
          alt="Background"
        />
        <div className="button-kaVUlA">
          <div
            className="site-de-casamento-e-gcDLS5"
            dangerouslySetInnerHTML={{ __html: warningMessage }}
          />
          <div className="button-gcDLS5 smart-layers-pointers">
            <div className="pular-introduo-ZdVp8v" onClick={onSkipIntro}>
              {buttonMessage}
            </div>
          </div>
        </div>
        <div className="couple-name-kaVUlA bp2-animate-enter2">
          <div className="e-zk2cMo canela-light-white-72px bp2-animate-enter">
            <span className="span1-ux4d12 canela-light-ivory-72px">
              {coupleSimplifiedName.bride}
            </span>
          </div>
          <img
            className="heart-divider-kaVUlA bp2-animate-enter3"
            src={heartImg}
            alt="Heart Divider"
          />
          <div className="m-zk2cMo canela-light-white-72px bp2-animate-enter1">
            <span className="span0-QT8Hdb canela-light-ivory-72px">
              {coupleSimplifiedName.groom && `${coupleSimplifiedName.groom}`}
            </span>
          </div>
        </div>
      </div>
      <div className="animated-intro-large screen">
        <img
          className="background-p4EdWL"
          src={background || backgroundImg}
          alt="Background"
        />
        <div className="button-p4EdWL">
          <div
            className="site-de-casamento-e-CpwLjN"
            dangerouslySetInnerHTML={{ __html: warningMessage }}
          />
          <div className="button-CpwLjN smart-layers-pointers">
            <div className="pular-introduo-fo8x79" onClick={onSkipIntro}>
              {buttonMessage}
            </div>
          </div>
        </div>
        <div className="couple-name-p4EdWL bp1-animate-enter2">
          <div className="e-VF7rnS canela-light-white-72px bp1-animate-enter">
            <span className="span1-iTGjt4 canela-light-ivory-72px">
              {coupleSimplifiedName.bride}
            </span>
          </div>
          <img
            className="heart-divider-p4EdWL bp1-animate-enter3"
            src={heartImg}
            alt="Heart Divider"
          />
          <div className="m-VF7rnS canela-light-white-72px bp1-animate-enter1">
            <span className="span0-LBUkaO canela-light-ivory-72px">
              {coupleSimplifiedName.groom && `${coupleSimplifiedName.groom}`}
            </span>
          </div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
